var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPincode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3992 0.799805H2.59922C1.27922 0.799805 0.199219 1.8798 0.199219 3.1998V12.7998C0.199219 14.1198 1.27922 15.1998 2.59922 15.1998H19.3992C20.7192 15.1998 21.7992 14.1198 21.7992 12.7998V3.1998C21.7992 1.8798 20.7192 0.799805 19.3992 0.799805ZM9.31922 6.7998L8.83922 7.15981C8.35922 7.63981 8.23922 8.4798 8.59922 9.0798L7.63922 10.0398L6.31922 8.71981L4.75922 10.2798C4.51922 10.5198 2.83922 11.8398 2.59922 11.5998C2.35922 11.3598 3.67922 9.6798 3.91922 9.43981L5.47922 7.8798L4.15922 6.5598L5.11922 5.5998C5.71922 5.95981 6.55922 5.95981 7.03922 5.35981L7.39922 4.9998C7.99922 4.3998 7.99922 3.5598 7.63922 2.95981L8.59922 1.9998L12.1992 5.4798L11.2392 6.4398C10.6392 6.1998 9.79922 6.1998 9.31922 6.7998ZM15.7992 8.5998L13.9992 10.3998L15.7992 12.1998V13.9998L12.1992 10.3998L15.7992 6.7998V8.5998ZM16.9992 13.9998V12.1998L18.7992 10.3998L16.9992 8.5998V6.7998L20.5992 10.3998L16.9992 13.9998Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPincode);
export default __webpack_public_path__ + "static/media/pincode.32ca7e21d69f0c9163b7cd3370b547b2.svg";
export { ForwardRef as ReactComponent };